import domReady from '@wordpress/dom-ready';

domReady( () => {
	( function ( $ ) {
		$( window ).on( 'load', function () {
			const tabsWrap = $( '.wp-block-flywp-theme-companion-tabs' );
			const wpbTabsBlockSettings = $( tabsWrap ).attr(
				'data-wpb-tabs-block-settings'
			);
			const attributes = JSON.parse( wpbTabsBlockSettings );
			const { tabsTrigger, initialActiveTab } = attributes;

			const initialTabButton = $( tabsWrap ).find(
				'.wp-block-flywp-theme-companion-tab-button'
			)[ initialActiveTab - 1 ];
			const initialTabContent = $( tabsWrap ).find(
				'.wp-block-flywp-theme-companion-tab-content'
			)[ initialActiveTab - 1 ];

			$( initialTabButton ).addClass( 'flywp-theme-companion-tabs-active' );
			$( initialTabContent ).addClass( 'flywp-theme-companion-tabs-active' );

			tabsWrap.each( function () {
				const tabButtons = $( this ).find(
					'.wp-block-flywp-theme-companion-tab-button'
				);
				const tabContents = $( this ).find(
					'.wp-block-flywp-theme-companion-tab-content'
				);

				tabButtons.each( function ( index ) {
					$( this ).on( tabsTrigger, function () {
						tabButtons.each( function ( i, ele ) {
							$( ele ).removeClass( 'flywp-theme-companion-tabs-active' );
						} );
						tabContents.each( function ( i, ele ) {
							$( ele ).removeClass( 'flywp-theme-companion-tabs-active' );
						} );
						$( this ).addClass( 'flywp-theme-companion-tabs-active' );
						$( tabContents[ index ] ).addClass(
							'flywp-theme-companion-tabs-active'
						);
					} );
				} );
			} );
		} );

		// eslint-disable-next-line no-undef
	} )( jQuery );
} );
